module.exports = __webpack_public_path__ + "static/venturecenter-banner-5aa4769e3b24ee8856b0c2c4ff1cb328.png";